import type {CpcCampaignOverview} from './types';

import {dateToReadableDate} from '@date-picker';
import {Chip} from '@ds/components';
import {getStatusChipProps} from 'common/status-chip/getStatusChipProps';
import CpcInfoRow from 'modules/Cpc/components/common/CpcInfoRow/CpcInfoRow';
import {numberFormat} from 'utils/Helper';

import {getCpcStateLabel} from '../../../utils';

type CampaignOverviewProps = {
  campaign: CpcCampaignOverview;
};

const CampaignOverview: React.FC<CampaignOverviewProps> = ({campaign}) => {
  const displayedState = campaign.hold ? 'paused' : campaign.state;
  const statusChipProps = getStatusChipProps(displayedState);

  return (
    <section>
      <div className="flex min-h-15 items-center justify-between gap-3 border-b border-gray-03 px-4 py-3">
        <span className="text-body-sm text-gray-07">وضعیت</span>
        <Chip
          label={getCpcStateLabel(displayedState)}
          variant={statusChipProps.variant}
          color={statusChipProps.color}
          size="sm"
          interactive={false}
        />
      </div>
      <CpcInfoRow
        title="تاریخ شروع"
        value={dateToReadableDate({
          date: campaign.start_date,
          day: true,
          month: true,
          year: true
        })}
      />
      {campaign.end_date ? (
        <CpcInfoRow
          title="تاریخ پایان"
          value={dateToReadableDate({
            date: campaign.end_date,
            day: true,
            month: true,
            year: true
          })}
        />
      ) : null}
      <CpcInfoRow title="نوع کمپین" value={campaign.renewal ? 'تکرار شونده' : 'عادی'} />
      {campaign.payment_tax_rate >= 0 ? (
        <CpcInfoRow
          title="درصد مالیات"
          value={`${numberFormat(campaign.payment_tax_rate || 0)}%`}
        />
      ) : null}
      {campaign.payment_price >= 0 ? (
        <CpcInfoRow title="مبلغ فاکتور" value={numberFormat(campaign.payment_price || 0)} />
      ) : null}
      {campaign.payment_total_price >= 0 ? (
        <CpcInfoRow title="جمع کل" value={numberFormat(campaign.payment_total_price || 0)} />
      ) : null}
      {campaign.transaction_code ? (
        <CpcInfoRow
          title="شناسه تراکنش"
          value={<span className="underline">{campaign.transaction_code}</span>}
          hasBorder={false}
        />
      ) : null}
    </section>
  );
};

export default CampaignOverview;
